import type { FeatureMiddleware } from '@cast/api-client';
import {
  clusterHibernationSchedulesListModifier,
  clusterHibernationSchedulesListJson,
} from '@cast/fixtures';
import { ClusterAutoscalerPoliciesV2 } from '@cast/types-cluster-autoscaler';
import { DEMO_CLUSTER_ID } from '@cast/utils';

import {
  getIsClusterDemoMode,
  getIsOpDemoMode,
} from '@cast/infrastructure-demo';

import { rejectDemoClusterRequest } from '../utils';

const demoPoliciesV2: ClusterAutoscalerPoliciesV2 = {
  enabled: true,
  scopedMode: false,
  version: '1',
  nodeDownscaler: {
    emptyNodesEnabled: false,
    emptyNodesDelay: '5s',
  },
  unschedulablePods: {
    enabled: false,
    partialTemplateMatchingEnabled: false,
    podPinner: {
      enabled: false,
      status: 'POD_PINNER_STATUS_COMPATIBLE',
    },
  },
  clusterLimits: {
    enabled: false,
    cpu: {
      minCores: 1,
      maxCores: 20,
    },
  },
};

export const clusterAutoscaler: FeatureMiddleware<'clusterAutoscaler'> = {
  getHibernationSchedules: async ({ args, next, resolve }) => {
    if (getIsClusterDemoMode()) {
      const result = clusterHibernationSchedulesListModifier(
        JSON.stringify(clusterHibernationSchedulesListJson()),
        args[0].organizationId,
        DEMO_CLUSTER_ID
      );
      return resolve(result);
    }
    return next();
  },
  getPoliciesV2: async ({ next, resolve }) => {
    if (getIsOpDemoMode() || getIsClusterDemoMode()) {
      return resolve(demoPoliciesV2);
    }
    return next();
  },
  updatePoliciesV2: async ({ next }) => {
    if (getIsOpDemoMode() || getIsClusterDemoMode()) {
      return rejectDemoClusterRequest();
    }
    return next();
  },
};
